import { Repository } from "../../adapters/repository";
import { present } from "../../../utils/presenter";
import { Interactor } from "./types";

function createInteractor(repository: Repository): Interactor {
  return ({ resourceType, groupId }) =>
    present(
      repository
        .getResourceGroup(resourceType, groupId)
        .then((group) => ({ resourceType, group }))
        .catch(() => Promise.reject({ resourceType, groupId })),
    );
}

export type { Interactor };

export { createInteractor };
